/**
 * DNINE WARRANTY REGISTRATION FORM HANDLER V2
 * Wrapped entirely in IIFE to avoid Shopify global scope conflicts (const style bug)
 */
(function() {
  'use strict';

  var form, submitBtn, successEl, errorEl, customer, googleScriptUrl;
  var isSubmitting = false;
  var uploadedFileData = null;
  var uploadedProductImages = [];

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    form = document.getElementById('warranty-form');
    if (!form) return;

    submitBtn = document.getElementById('warranty-submit-btn');
    successEl = document.getElementById('warranty-success');
    errorEl = document.getElementById('warranty-error');
    customer = (window.Shopify && window.Shopify.customer) ? window.Shopify.customer : null;
    googleScriptUrl = window.DNINE_GOOGLE_SCRIPT_URL ||
      'https://script.google.com/macros/s/AKfycbwGLxupDhzM09IvIXD8OBnkcDGOWf-o7BQku1LyhbkrcwEuE-r0DfY_PXz0LoEWRlBn_g/exec';

    console.log('Warranty Form V2: Initializing...');

    // Auto-fill customer data
    if (customer) autoFillCustomer();

    // Setup all interactions
    setupProductDropdown();
    setupProductSearch();
    setupProductCheckboxes();
    setupPurchasePoint();
    setupFileUpload();
    setupTCToggle();
    setupTCAccordion();
    setupValidation();
    handleUrlParameters();

    // Submit handler — use button click to bypass Shopify native form submit
    if (submitBtn) {
      submitBtn.type = 'button';
      submitBtn.addEventListener('click', handleSubmit);
    }

    console.log('Warranty Form V2: Ready');
  }

  /* ===== AUTO-FILL ===== */
  function autoFillCustomer() {
    var nameField = document.getElementById('warranty-name');
    var emailField = document.getElementById('warranty-email');
    var phoneField = document.getElementById('warranty-phone');

    if (nameField && customer.name && !nameField.value) {
      nameField.value = customer.name;
      nameField.style.backgroundColor = '#f0fdf4';
    }
    if (emailField && customer.email && !emailField.value) {
      emailField.value = customer.email;
      emailField.style.backgroundColor = '#f0fdf4';
    }
    if (phoneField) {
      var phone = customer.phone || (customer.default_address && customer.default_address.phone) || '';
      if (phone && !phoneField.value) {
        phoneField.value = phone;
        phoneField.style.backgroundColor = '#f0fdf4';
      }
    }
  }

  /* ===== DROPDOWN TOGGLE ===== */
  function setupProductDropdown() {
    var wrapper = document.getElementById('wr-products-wrapper');
    var trigger = document.getElementById('wr-product-trigger');
    var dropdown = document.getElementById('wr-product-dropdown');
    var searchInput = document.getElementById('warranty-product-search');
    var doneBtn = document.getElementById('wr-done-btn');
    if (!trigger || !dropdown) return;

    function openDropdown() {
      trigger.classList.add('wr-trigger--open');
      dropdown.classList.add('wr-dropdown--open');
      if (searchInput) {
        setTimeout(function() { searchInput.focus(); }, 50);
      }
    }

    function closeDropdown() {
      trigger.classList.remove('wr-trigger--open');
      dropdown.classList.remove('wr-dropdown--open');
      if (searchInput) {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input'));
      }
    }

    function toggleDropdown() {
      if (dropdown.classList.contains('wr-dropdown--open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    }

    trigger.addEventListener('click', function(e) {
      if (e.target.closest('.wr-tag__remove')) return;
      toggleDropdown();
    });

    if (doneBtn) {
      doneBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closeDropdown();
      });
    }

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (wrapper && !wrapper.contains(e.target)) {
        closeDropdown();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && dropdown.classList.contains('wr-dropdown--open')) {
        closeDropdown();
      }
    });
  }

  /* ===== PRODUCT SEARCH ===== */
  function setupProductSearch() {
    var searchInput = document.getElementById('warranty-product-search');
    var noResults = document.getElementById('wr-no-results');
    if (!searchInput) return;

    searchInput.addEventListener('input', function() {
      var query = this.value.toLowerCase().trim();
      var items = document.querySelectorAll('.wr-product-item');
      var visibleCount = 0;
      items.forEach(function(item) {
        var text = item.textContent.toLowerCase();
        var show = text.includes(query);
        item.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      });
      if (noResults) {
        noResults.style.display = (visibleCount === 0 && query.length > 0) ? 'block' : 'none';
      }
    });
  }

  /* ===== PRODUCT CHECKBOXES ===== */
  function setupProductCheckboxes() {
    var checkboxes = form.querySelectorAll('.wr-product-cb');
    var countEl = document.getElementById('wr-selected-count');
    var trigger = document.getElementById('wr-product-trigger');
    var placeholder = document.getElementById('wr-trigger-placeholder');

    if (!checkboxes.length) return;

    function updateSelection() {
      var checked = form.querySelectorAll('.wr-product-cb:checked');

      // Update count in dropdown footer
      if (countEl) {
        countEl.style.display = checked.length > 0 ? 'block' : 'none';
        var num = countEl.querySelector('.wr-count-num');
        if (num) num.textContent = checked.length;
      }

      // Update trigger tags
      if (trigger) {
        // Remove old tags
        var oldTags = trigger.querySelectorAll('.wr-tag, .wr-tag__more');
        oldTags.forEach(function(t) { t.remove(); });

        if (checked.length > 0) {
          if (placeholder) placeholder.style.display = 'none';
          var arrow = trigger.querySelector('.wr-trigger__arrow');
          var maxTags = window.innerWidth < 750 ? 1 : 2;

          checked.forEach(function(cb, i) {
            if (i < maxTags) {
              var tag = document.createElement('span');
              tag.className = 'wr-tag';
              tag.innerHTML = '<span class="wr-tag__text">' + cb.value + '</span><button type="button" class="wr-tag__remove" aria-label="Remove">&times;</button>';
              tag.querySelector('.wr-tag__remove').addEventListener('click', function(e) {
                e.stopPropagation();
                cb.checked = false;
                var parentItem = cb.closest('.wr-product-item');
                if (parentItem) parentItem.classList.remove('wr-product-item--selected');
                updateSelection();
              });
              if (arrow) {
                trigger.insertBefore(tag, arrow);
              } else {
                trigger.appendChild(tag);
              }
            }
          });

          if (checked.length > maxTags) {
            var more = document.createElement('span');
            more.className = 'wr-tag__more';
            more.textContent = '+' + (checked.length - maxTags) + ' more';
            if (arrow) {
              trigger.insertBefore(more, arrow);
            } else {
              trigger.appendChild(more);
            }
          }
        } else {
          if (placeholder) placeholder.style.display = '';
        }
      }

      // Highlight selected items in list
      checkboxes.forEach(function(cb) {
        var parentItem = cb.closest('.wr-product-item');
        if (parentItem) {
          parentItem.classList.toggle('wr-product-item--selected', cb.checked);
        }
      });
    }

    checkboxes.forEach(function(cb) {
      cb.addEventListener('change', updateSelection);
    });
  }

  /* ===== POINT OF PURCHASE ===== */
  function setupPurchasePoint() {
    var select = document.getElementById('warranty-purchase-point');
    var storeField = document.getElementById('warranty-store-field');
    if (!select || !storeField) return;

    select.addEventListener('change', function() {
      var storeInput = document.getElementById('warranty-store-location');
      if (this.value === 'Retail Outlet') {
        storeField.style.display = 'block';
        if (storeInput) storeInput.required = true;
      } else {
        storeField.style.display = 'none';
        if (storeInput) {
          storeInput.required = false;
          storeInput.value = '';
        }
      }
    });
  }

  /* ===== FILE UPLOAD ===== */
  function setupFileUpload() {

/* =========================
INVOICE UPLOAD
========================= */

var fileInput = document.getElementById('warranty-invoice-upload');
var uploadArea = document.getElementById('wr-upload-area');
var uploadDone = document.getElementById('wr-upload-done');
var fileName = document.getElementById('wr-file-name');
var removeBtn = document.getElementById('wr-file-remove');

if (fileInput) {


fileInput.addEventListener('change', function(e) {

  var file = e.target.files[0];
  if (!file) return;

  var maxSize = 5 * 1024 * 1024;
  var allowedTypes = [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png'
  ];

  if (file.size > maxSize) {
    alert('File is too large. Maximum size is 5MB.');
    fileInput.value = '';
    return;
  }

  if (!allowedTypes.includes(file.type)) {
    alert('Invalid file type. Please upload PDF, JPG, or PNG only.');
    fileInput.value = '';
    return;
  }

  if (uploadArea) uploadArea.style.display = 'none';
  if (uploadDone) uploadDone.style.display = 'flex';
  if (fileName) fileName.textContent = file.name;

  var reader = new FileReader();

  reader.onload = function(ev) {

    uploadedFileData = {
      name: file.name,
      type: file.type,
      size: file.size,
      data: ev.target.result.split(',')[1]
    };

    window.warrantyFileData = uploadedFileData;

  };

  reader.readAsDataURL(file);

});

if (removeBtn) {

  removeBtn.addEventListener('click', function() {

    fileInput.value = '';
    uploadedFileData = null;
    window.warrantyFileData = null;

    if (uploadArea) uploadArea.style.display = 'flex';
    if (uploadDone) uploadDone.style.display = 'none';

  });

}


}

/* =========================
PRODUCT IMAGES
========================= */

var productInput =
document.getElementById('warranty-product-images');

var productUploadArea =
document.getElementById('wr-product-upload-area');

var productUploadDone =
document.getElementById('wr-product-upload-done');

var productFileName =
document.getElementById('wr-product-file-name');

var productRemoveBtn =
document.getElementById('wr-product-file-remove');

if (productInput) {


productInput.addEventListener('change', function(e) {

  var files = Array.from(e.target.files || []);

  if (!files.length) return;

  if (files.length > 3) {

    alert('Maximum 3 images allowed.');

    productInput.value = '';

    return;

  }

  uploadedProductImages = [];

  var processed = 0;

  files.forEach(function(file) {

    if (file.size > (5 * 1024 * 1024)) {

      alert(
        'Each image must be smaller than 5MB.'
      );

      return;

    }

    var reader = new FileReader();

    reader.onload = function(ev) {

      uploadedProductImages.push({

        name: file.name,
        type: file.type,
        size: file.size,
        data: ev.target.result.split(',')[1]

      });

      processed++;

      if (processed === files.length) {

        if (productUploadArea) {
          productUploadArea.style.display = 'none';
        }

        if (productUploadDone) {
          productUploadDone.style.display = 'flex';
        }

        if (productFileName) {

          productFileName.textContent =
            uploadedProductImages.length +
            ' image(s) selected';

        }

      }

    };

    reader.readAsDataURL(file);

  });

});

if (productRemoveBtn) {

  productRemoveBtn.addEventListener('click', function() {

    uploadedProductImages = [];

    productInput.value = '';

    if (productUploadArea) {
      productUploadArea.style.display = 'flex';
    }

    if (productUploadDone) {
      productUploadDone.style.display = 'none';
    }

  });

}

}

}


  /* ===== T&C TOGGLE ===== */
  function setupTCToggle() {
    var toggle = document.getElementById('warranty-tc-toggle');
    var section = document.getElementById('warranty-tc-section');
    if (!toggle || !section) return;

    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      var isHidden = section.style.display === 'none' || !section.style.display;
      section.style.display = isHidden ? 'block' : 'none';
      if (isHidden) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ===== T&C ACCORDION ===== */
  function setupTCAccordion() {
    document.addEventListener('click', function(e) {
      var header = e.target.closest('.wr-tc-header');
      if (!header) return;
      var body = header.nextElementSibling;
      var icon = header.querySelector('.wr-tc-icon');
      if (!body) return;
      var isOpen = body.style.display === 'block';
      body.style.display = isOpen ? 'none' : 'block';
      if (icon) icon.textContent = isOpen ? '+' : '−';
    });
  }

  /* ===== URL PARAMETERS (QR CODES) ===== */
  function handleUrlParameters() {
    var params = new URLSearchParams(window.location.search);
    var productHandle = params.get('product');
    if (productHandle) {
      var checkboxes = form.querySelectorAll('.wr-product-cb');
      checkboxes.forEach(function(cb) {
        if (cb.dataset.handle === productHandle) {
          cb.checked = true;
          cb.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  }

  /* ===== VALIDATION ===== */
  function setupValidation() {
    var emailInput = document.getElementById('warranty-email');
    var phoneInput = document.getElementById('warranty-phone');

    if (emailInput) {
      emailInput.addEventListener('blur', function() {
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        this.classList.toggle('wr-error', !re.test(this.value));
      });
      emailInput.addEventListener('input', function() {
        this.classList.remove('wr-error');
      });
    }

    if (phoneInput) {
      phoneInput.addEventListener('blur', function() {
        var clean = this.value.replace(/[\s\-()]/g, '');
        var re = /^(\+91|91|0)?[6-9]\d{9}$/;
        this.classList.toggle('wr-error', clean.length > 0 && !re.test(clean));
      });
      phoneInput.addEventListener('input', function() {
        this.classList.remove('wr-error');
      });
    }
  }

  /* ===== WARRANTY ID ===== */
  function generateWarrantyId() {
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var id = 'WRN-';
    for (var i = 0; i < 3; i++) {
      for (var j = 0; j < 3; j++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      if (i < 2) id += '-';
    }
    return id;
  }

  /* ===== VALIDATE ===== */
  function validateForm() {
    var checked = form.querySelectorAll('.wr-product-cb:checked');
    if (checked.length === 0) {
      showError('Please select at least one product.');
      var list = document.getElementById('warranty-product-list');
      if (list) list.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }

    var name = document.getElementById('warranty-name');
    var email = document.getElementById('warranty-email');
    var phone = document.getElementById('warranty-phone');
    var altPhone = document.getElementById('warranty-alt-phone');
    var orderId = document.getElementById('warranty-order-id');
    var productSize = document.getElementById('warranty-product-size');
    var purchaseDate = document.getElementById('warranty-date');
    var point = document.getElementById('warranty-purchase-point');
    var storeLoc = document.getElementById('warranty-store-location');

    if (!name || !name.value.trim()) { if (name) name.focus(); showError('Please enter your name.'); return false; }

    var emailVal = email ? email.value.trim() : '';
    if (!emailVal || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
      if (email) email.focus(); showError('Please enter a valid email address.'); return false;
    }

    var phoneVal = phone ? phone.value.replace(/[\s\-()]/g, '') : '';
    if (!phoneVal || !/^(\+91|91|0)?[6-9]\d{9}$/.test(phoneVal)) {
      if (phone) phone.focus(); showError('Please enter a valid 10-digit mobile number.'); return false;
    }

    if (!point || !point.value) {
      if (point) point.focus(); showError('Please select point of purchase.'); return false;
    }

    if (point && point.value === 'Retail Outlet' && storeLoc && !storeLoc.value.trim()) {
      storeLoc.focus(); showError('Please enter the store location.'); return false;
    }

    if (!orderId || !orderId.value.trim()) {
      orderId.focus();
      showError('Please enter Order ID.');
      return false;
   }

    if (!purchaseDate || !purchaseDate.value) {
     if (purchaseDate) purchaseDate.focus();
      showError('Please select purchase date.');
      return false;
   }

    if (!productSize || !productSize.value.trim()) {
      productSize.focus();
      showError('Please enter Product Size.');
      return false;
   }


    // File upload is required
    if (!uploadedFileData && !window.warrantyFileData) {
      showError('Please upload your invoice or receipt.');
      var uploadEl = document.getElementById('wr-upload-area');
      if (uploadEl) uploadEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }

    if (!uploadedProductImages || uploadedProductImages.length === 0) {

  showError('Please upload at least one product image.');

  var imageUpload =
    document.getElementById('wr-product-upload-area');

  if (imageUpload) {
    imageUpload.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  return false;
}

    return true;
  }

  /* ===== COLLECT DATA ===== */
  function collectFormData(warrantyId) {
    var checked = form.querySelectorAll('.wr-product-cb:checked');
    var products = [];
    checked.forEach(function(cb) {
      products.push({ title: cb.value, handle: cb.dataset.handle || '' });
    });

    var fileData = uploadedFileData || window.warrantyFileData || null;

    // Build store location string matching what Google Apps Script expects
    var purchasePoint = (document.getElementById('warranty-purchase-point') || {}).value || '';
    var storeLocInput = (document.getElementById('warranty-store-location') || {}).value || '';
    var storeLocation = purchasePoint;
    if (purchasePoint === 'Retail Outlet' && storeLocInput) {
      storeLocation = 'Retail Outlet - ' + storeLocInput;
    }

    return {
      formType: 'warranty',
      timestamp: new Date().toISOString(),
      warrantyId: warrantyId,
      products: products,
      productNames: products.map(function(p) { return p.title; }).join(', '),
      productCount: products.length,
      customerName: (document.getElementById('warranty-name') || {}).value || '',
      email: (document.getElementById('warranty-email') || {}).value || '',
      phone: (document.getElementById('warranty-phone') || {}).value || '',
      alternatePhone:(document.getElementById('warranty-alt-phone') || {}).value || '',
      orderId:(document.getElementById('warranty-order-id') || {}).value || '',
      productSize:(document.getElementById('warranty-product-size') || {}).value || '',
      purchaseDate: (document.getElementById('warranty-date') || {}).value || '',
      pointOfPurchase: purchasePoint,
      storeLocation: storeLocation,
      notes: (document.getElementById('warranty-notes') || {}).value || '',
      marketingOptIn: (document.getElementById('warranty-marketing') || {}).checked || false,
      productImages: uploadedProductImages || [],
      invoiceFile: fileData,
      source: new URLSearchParams(window.location.search).get('product') ? 'QR Code' : 'Manual',
      shopifyCustomerId: customer ? customer.id : null,
      shopifyCustomerEmail: customer ? customer.email : null
    };
  }

  /* ===== SUBMIT ===== */
  function handleSubmit() {
    if (isSubmitting) return;
    hideMessages();

    if (!validateForm()) return;

    isSubmitting = true;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.origHtml = submitBtn.innerHTML;
      submitBtn.innerHTML = '<span class="wr-spinner"></span> Registering...';
    }

    var warrantyId = generateWarrantyId();
    var formData = collectFormData(warrantyId);

    console.log('Warranty Form V2: Submitting...', {
      warrantyId: formData.warrantyId,
      products: formData.productNames,
      email: formData.email,
      pointOfPurchase: formData.pointOfPurchase
    });

    fetch(googleScriptUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(formData)
    })
    .then(function() {
      console.log('Warranty Form V2: Submitted successfully');
      console.log('Warranty Form V2: Payload sent:', {
        warrantyId: formData.warrantyId,
        hasFile: !!formData.invoiceFile,
        fileName: formData.invoiceFile ? formData.invoiceFile.name : 'none',
        fileSize: formData.invoiceFile ? formData.invoiceFile.size : 0,
        customerId: formData.shopifyCustomerId,
        storeLocation: formData.storeLocation,
        marketingOptIn: formData.marketingOptIn
      });
      showSuccessPopup(warrantyId, formData.email);
    })
    .catch(function(error) {
      console.error('Warranty Form V2: Error:', error);
      showError('Something went wrong. Please try again or contact support at admin@dninesports.com');
    })
    .finally(function() {
      isSubmitting = false;
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = submitBtn.dataset.origHtml || 'Register My Warranty';
      }
    });
  }

  /* ===== SUCCESS POPUP ===== */
  function showSuccessPopup(warrantyId, email) {
    var popup = document.getElementById('warranty-success-popup');
    var idDisplay = document.getElementById('warranty-id-display');
    var emailDisplay = document.getElementById('warranty-email-display');

    if (idDisplay) idDisplay.textContent = warrantyId;
    if (emailDisplay) emailDisplay.textContent = email;

    if (popup) {
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    // Close handlers
    var closeBtn = document.getElementById('warranty-popup-close');
    if (closeBtn) {
      closeBtn.onclick = function() { closePopup(popup); };
    }
    if (popup) {
      popup.onclick = function(e) {
        if (e.target === popup) closePopup(popup);
      };
    }

    // Reset form
    form.reset();
    uploadedFileData = null;
    window.warrantyFileData = null;

    // Reset UI
    var storeField = document.getElementById('warranty-store-field');
    if (storeField) storeField.style.display = 'none';
    var uploadArea = document.getElementById('wr-upload-area');
    var uploadDone = document.getElementById('wr-upload-done');
    if (uploadArea) uploadArea.style.display = 'flex';
    if (uploadDone) uploadDone.style.display = 'none';

    // Reset product dropdown trigger tags
    var trigger = document.getElementById('wr-product-trigger');
    if (trigger) {
      var oldTags = trigger.querySelectorAll('.wr-tag, .wr-tag__more');
      oldTags.forEach(function(t) { t.remove(); });
      var placeholder = document.getElementById('wr-trigger-placeholder');
      if (placeholder) placeholder.style.display = '';
    }
    // Reset selected highlights in product list
    var selectedItems = document.querySelectorAll('.wr-product-item--selected');
    selectedItems.forEach(function(item) { item.classList.remove('wr-product-item--selected'); });
    // Reset count footer
    var count = document.getElementById('wr-selected-count');
    if (count) count.style.display = 'none';

    if (customer) autoFillCustomer();
  }

  function closePopup(popup) {
    if (popup) popup.style.display = 'none';
    document.body.style.overflow = '';
  }

  /* ===== MESSAGES ===== */
  function showError(msg) {
    hideMessages();
    if (errorEl) {
      var textEl = errorEl.querySelector('.wr-error-text');
      if (textEl) textEl.textContent = msg;
      errorEl.style.display = 'block';
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function hideMessages() {
    if (successEl) successEl.style.display = 'none';
    if (errorEl) errorEl.style.display = 'none';
  }

})();
